import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate } from "../Helpers";
import { STR_ACTIVE_BUSINESS, STR_BUY_NOW, STR_CHANGE_BUSINESS, STR_NO_BUSINESS_WAS_SELECTED, STR_PLEASE_REGISTER_BUSINESS, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_REGISTER_BUSINESS, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";
import { TiWarningOutline } from "react-icons/ti";
import { RiExchangeBoxLine } from "react-icons/ri";

export default function CurrentBusinessWidget({ }) {
	const appContext = useContext(AppContext);

	/* Place states here */

	async function init() {
    //sync user data in bg
    await Promise.all([
      appContext.getCurrentUserData(),
    ])
  }

	useEffect(() => {
    init();
  }, [])

	return (
		<div 
			className="card"
		>
			<div className="card-body">
				<h6
					className="font-light text-start"
					style={{
						fontSize: "18px",
						textTransform: "uppercase"
					}}
				>
					<span className="badge bg-secondary">{STR_ACTIVE_BUSINESS[appContext.language]}</span>
				</h6>

				{
					(appContext.currentBusiness) ?
					<h6
						style={{
							fontSize: "20px"
						}}
						className="font-bold text-secondary"
					>
						{appContext.currentBusiness.businessName}
					</h6>
					:
					<h6
						style={{
							fontSize: "12px"
						}}
					>
						{STR_NO_BUSINESS_WAS_SELECTED[appContext.language]}
					</h6>
				}

				{
					(appContext.currentUserData && appContext.currentUserData.businesses.length > 0) ?
					<div
						className="text-end d-none"
					>
						<button
							className="btn btn-sm"
							onClick={() => {
								appContext.navTo({
									item: 'view',
									subItem: 'change-business',
								})
							}}
							
						>
							<RiExchangeBoxLine size={24} /> {STR_CHANGE_BUSINESS[appContext.language]}
						</button>
					</div>
					:
					<div>
						<hr/>
						<h6
							style={{
								fontSize: "14px"
							}}
							className="font-semi-bold"
						>
							<TiWarningOutline size={42}/>
							<br/>
							{STR_PLEASE_REGISTER_BUSINESS[appContext.language]}
						</h6>

						<div className="text-end">
							<button
								className="btn  btn-padded btn-rounded btn-primary mt-4"
								onClick={() => {
									appContext.navTo({
										item: 'view',
										subItem: 'register-business',
									})
								}}
							>
								{STR_REGISTER_BUSINESS[appContext.language]}
							</button>
						</div>
					</div>
				}
			</div>
		</div>
	);
}
